import React, { useState } from "react";
import {Redirect} from 'react-router-dom';
import { Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import { onError } from "../libs/errorLib";
import Copyright from "../components/Copyright";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState(""); 
  const [confirmPassword, setConfirmPassword] = useState("");
  const [codeSent, setCodeSent] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const [isSendingCode, setIsSendingCode] = useState(false);

  function validateCodeForm() {
    return email.length > 0;
  }

  function validateResetForm(){
    return (
      code.length > 0 &&
      password.length > 0 &&
      password === confirmPassword
    );
  }

  async function handleSendCodeClick(event) {
    event.preventDefault();

    setIsSendingCode(true);
    try {
      await Auth.forgotPassword(email);
      setCodeSent(true);
    } catch (error) {
      onError(error);
    } finally{
      setIsSendingCode(false);
    } 
  }
  async function handleConfirmClick(event) {
    event.preventDefault();

    setIsConfirming(true);

    try {
      await Auth.forgotPasswordSubmit(email, code, password);
      setConfirmed(true);
    } catch (error) {
      onError(error);
    } finally {
      setIsConfirming(false);
    }
  }

  function renderRequestCodeForm() {
    return (
      <main>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="card shadow-lg border-0 rounded-lg mt-5">
                <div className="card-header">
                  <h3 className="text-center font-weight-light my-4">
                    Forgot password
                  </h3>
                </div>
                <div className="card-body">
                  <Form>
                    <div className="form-group">
                      <label className="small mb-1" htmlFor="inputEmailAddress">
                        Email
                      </label>
                      <input
                        className="form-control py-4"
                        id="inputEmailAddress"
                        name="email"
                        type="email"
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter email address"
                      />
                    </div>
                    <div className="form-group d-flex align-items-center justify-content-between mt-4 mb-0 mr-1">
                      <Button
                        onClick={handleSendCodeClick}
                        disabled={isConfirming || isSendingCode || !validateCodeForm()}
                      >
                        Submit
                      </Button>
                      <Link to="/login">Cancel</Link>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  function renderConfirmationForm() {
    return (
      <main>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5">
              <div className="card shadow-lg border-0 rounded-lg mt-5">
                <div className="card-header">
                  <h3 className="text-center font-weight-light my-4">
                    Change password 
                  </h3>
                </div>
                <div className="card-body">
                  <Form>
                    <div className="form-group">
                      <label className="small mb-1" htmlFor="inputConfirmationCode">
                        Confirmation code
                      </label>
                      <input
                        className="form-control py-4"
                        id="inputConfirmationCode"
                        name="code"
                        type="number"
                        onChange={(e) => setCode(e.target.value)}
                        placeholder="Enter confirmation code"
                      />
                    </div>
                    <div className="form-group">
                      <label className="small mb-1" htmlFor="inputPassword">
                        New password
                      </label>
                      <input
                        className="form-control py-4"
                        id="inputPassword"
                        name="password"
                        type="password"
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter new password"
                      />
                    </div>
                    <div className="form-group">
                      <label className="small mb-1" htmlFor="inputConfirmPassword">
                        Confirm password
                      </label>
                      <input
                        className="form-control py-4"
                        id="inputConfirmPassword"
                        name="confirmPassword"
                        type="password"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Re-enter new password"
                      />
                    </div>
                    <div className="form-group d-flex align-items-center justify-content-between mt-4 mb-0 mr-1">
                      <Button
                        onClick={handleConfirmClick}
                        disabled={isConfirming || isSendingCode || !validateResetForm()}
                      >
                        Submit
                      </Button>
                      <Link to="/login">Cancel</Link>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }

  function renderSuccessMessage() {
    return <Redirect to='/login/' />
  }
  return (
    <div id="layoutAuthentication">
      <div id="layoutAuthentication_content">
        {!codeSent
          ? renderRequestCodeForm()
          : !confirmed
          ? renderConfirmationForm()
          : renderSuccessMessage()}
      </div>
      <div id="layoutAuthentication_footer">
        <footer className="py-4 bg-light mt-auto">
          <div className="container-fluid">
            <div className="d-flex align-items-center justify-content-between small">
              <Copyright />
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
